import React, { ReactNode, useMemo } from 'react';
import { Checkbox, CheckboxGroup, VStack } from '@chakra-ui/react';

export function CheckboxList<T>(props: {
  items: Array<T>;
  getKey: (item: T, index: number) => string;
  renderLabel: (item: T) => ReactNode;
  selected: Set<string>;
  onSelectionChange: (selected: Set<string>) => void;
}) {
  const { items, getKey, renderLabel, selected, onSelectionChange } = props;
  const selectedArray = useMemo(() => Array.from(selected), [selected]);
  return (
    <CheckboxGroup
      value={selectedArray}
      onChange={(values) => {
        // Chakra thinks `values` is Array<string | number>
        const array = values as Array<string>;
        onSelectionChange(new Set(array));
      }}
    >
      <VStack alignItems="flex-start">
        {items.map((item, i) => {
          const key = getKey(item, i);
          return (
            <Checkbox key={key} value={key}>
              {renderLabel(item)}
            </Checkbox>
          );
        })}
      </VStack>
    </CheckboxGroup>
  );
}
